import * as React from 'react';

export enum ControlVariant {
  Default = 'default',
  Accent = 'accent',
}

export type ControlProps =
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> & {
  variant?: ControlVariant;
};
